import { render, staticRenderFns } from "./DealTitleColumn.vue?vue&type=template&id=7f0d90a4&"
import script from "./DealTitleColumn.vue?vue&type=script&lang=js&"
export * from "./DealTitleColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports